exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1AyM2{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column}._1AyM2 .au_aK{position:relative;flex-grow:2}\n", ""]);

// Exports
exports.locals = {
	"mainUiBlock": "_1AyM2",
	"tooltipContainerWrapper": "au_aK"
};